import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var ActivityType;
(function (ActivityType) {
    ActivityType["Login"] = "Login";
    ActivityType["UserCreated"] = "User created";
    ActivityType["UserUpdated"] = "User updated";
    ActivityType["UserDeleted"] = "User deleted";
    ActivityType["PayoutRuleCreated"] = "Payout rule created";
    ActivityType["PayoutRuleUpdated"] = "Payout rule updated";
    ActivityType["PayoutRuleDeleted"] = "Payout rule deleted";
    ActivityType["InvoiceCreated"] = "Invoice created";
})(ActivityType || (ActivityType = {}));
export const ActivityTypeMap = new Map([
    [ActivityType.Login, ActivityType.Login],
    [ActivityType.UserCreated, ActivityType.UserCreated],
    [ActivityType.UserUpdated, ActivityType.UserUpdated],
    [ActivityType.UserDeleted, ActivityType.UserDeleted],
    [ActivityType.PayoutRuleCreated, ActivityType.PayoutRuleCreated],
    [ActivityType.PayoutRuleUpdated, ActivityType.PayoutRuleUpdated],
    [ActivityType.PayoutRuleDeleted, ActivityType.PayoutRuleDeleted],
    [ActivityType.InvoiceCreated, ActivityType.InvoiceCreated],
]);
let ActivityTypesService = class ActivityTypesService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = ActivityTypeMap;
    }
    list() {
        return this._data;
    }
};
ActivityTypesService.ctorParameters = () => [
    { type: TranslateService }
];
ActivityTypesService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], ActivityTypesService);
export { ActivityTypesService };
